// extracted by mini-css-extract-plugin
export default {"container":"Azaq58","right":"JVdv21","text":"E931lt","recording":"WXKYBt","recordingText":"MbmWaC","tooltipContainer":"iT2bbx","controlButtonText":"qYcySX","leaveButton":"uS9mSg"};